export default "__VITE_ASSET__D2kLD1Km__"